import type { CoachingModal as Modal } from '@/core/state/appStore'

export const DOC_TO_MODAL: Record<string, Modal> = {
  erstgespraech: 'erstgespraech',
  avgs: 'avgs',
  bestaetigung: 'avgs',
  'bestaetigung-empty': 'avgs',
  bewilligung: 'bewilligung',
  vertrag: 'vertrag',
  ecn: 'ecn',
  'Aufnahme- und Potenzialanalyse': 'aufnahme-potenzialanalyse',
}

export const docModal = (name: string, sheet: boolean): Modal =>
  sheet ? 'dokument' : (DOC_TO_MODAL[name] ?? 'dokument')
